import apiService from '../services/apiService';
import { updateStoredUser } from '../services/authService';
import { FALLBACK_GROUP_PERMISSIONS } from './permissionDefaults';

/**
 * Prüft, ob der Benutzer ein Modul nutzen darf.
 * Wirksame Rechte = Gruppenrechte der Rolle + individuelle Sonderrechte; Admins dürfen alles.
 */
export function hasModule(user, moduleKey) {
  if (!user) return false;
  if (user.permissions === 'admin') return true;
  if (Array.isArray(user.effectivePermissions)) {
    return user.effectivePermissions.includes(moduleKey);
  }
  const role = user.permissions === 'technican' ? 'technician' : user.permissions;
  const fromGroup = FALLBACK_GROUP_PERMISSIONS[role] || [];
  const custom = Array.isArray(user.customPermissions) ? user.customPermissions : [];
  return fromGroup.includes(moduleKey) || custom.includes(moduleKey);
}

export function hasAnyModule(user, moduleKeys) {
  return moduleKeys.some(key => hasModule(user, key));
}

// Teile landen im Dispo-Warenkorb, wenn der Benutzer nur Disponenten-Bestellungen aufgeben darf
export function usesDispatcherCart(user) {
  return hasModule(user, 'dispatcher-orders') && !hasModule(user, 'cart');
}

/**
 * Lädt die aktuellen wirksamen Rechte vom Server und speichert sie beim Benutzer,
 * damit Änderungen an der Berechtigungsmatrix ohne erneutes Anmelden greifen.
 */
export async function refreshEffectivePermissions() {
  if (!navigator.onLine) return null;
  try {
    const { permissions } = await apiService.get('/auth/permissions');
    if (Array.isArray(permissions)) {
      await updateStoredUser({ effectivePermissions: permissions });
      return permissions;
    }
  } catch (error) {
    console.warn('Berechtigungen konnten nicht aktualisiert werden:', error);
  }
  return null;
}
